import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, map, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { format } from 'date-fns';
import { ClrModal } from '@clr/angular';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import * as fs from 'file-saver'; // Importe a biblioteca file-saver
import * as ExcelJS from 'exceljs';
import { readFile } from 'xlsx';

interface ItemToExport {
  ID?: string,
  table_name?: string,
  Data?: string;
  Vehicle_configuration?: any;
  License_Plate?: any;
  Transportadora?: any;
  container?: any;
  consumo?: any;
  emissao?: any;
  emissaoTotal?: any;
  Ponto_Coleta1?: any;
  Ponto_Coleta2?: any;
  Ponto_Coleta3?: any;
  Ponto_Coleta4?: any;
  Ponto_Entrega1?: any;
  Ponto_Entrega2?: any;
  Ponto_Entrega3?: any;
  Ponto_Entrega4?: any;
  Qtde_Itens?: number;
  Cubagem_m3?: number;
  Peso_Total_Kg?: number;
  Distancia?: number;
  Custo_Viagem?: number;
}

@Component({
  selector: 'app-relatorios',
  templateUrl: './relatorios.component.html',
  styleUrls: ['./relatorios.component.css'],
  styles: [`
    .mat-dialog-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      background-color: #fff;
    }
  `],
  standalone: false
})

export class RelatoriosComponent {
  fieldBeingEdited!: string;
  editedValue: any;
  argentina!: any[];
  embalagensArray!: any[];
  interplantasArray!: any[];
  perfilVehicles: string[] = [
    'Pequeno',
    'Medio',
    'Grande',

  ];
  combustiveis: string[] = [
    'Diesel',
    'Gás',
    'Elétrico',

  ];
  item: any = {
    ID: '',
    local: '',
    contato: '',
    endereco: '',
    latitude: '',
    longitude: '',
    descarga: false
  };
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsultaCompleta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  urlConsultaRangeDatas: string = 'https://5eqqes9yi5.execute-api.sa-east-1.amazonaws.com/v1';
  query: string = 'Itens_Jetta';
  queryContainer: string = 'items_Excel_Container';
  querycontainerEXP: string = 'Container_exportacao';
  query2: string = 'Carriers';
  query3: string = 'tipos_Veiculos_Karrara';
  queryVeiculosLab: string = 'veiculos_lab_Karrara';
  query4: string = 'items_Excel_Karrara';
  queryInterplantas: string = 'Operacao_Interplantas_Karrara';
  queryInterplantasAmb: string = 'relatorioPreenchidoInterplantas';
  searchText: string = "";
  data: any;
  base: number = 3;
  ID: number = Date.now();
  local: string = "";
  contato: string = "";
  endereco: string = "";
  comentario: string = "";
  exponent: number = 22;
  $even: any;
  $odd: any;
  dataSource: any;
  dialogRef: any;
  items$!: Observable<any[]>;
  items: any[] = [];
  name!: string;
  animal!: string;
  dialogOpen = false;
  dialogTiposOpen = false;
  carrier!: any[];
  veiculos!: any[];
  veiculosLAB!: any[];
  teste!: boolean;
  startDate!: string;
  endDate!: string;
  milkRunSP: boolean = false;
  milkRunSul: boolean = false;
  milkRunArg: boolean = false;
  interplantas: boolean = false;
  embalagens: boolean = false;
  filteredItems!: any[];

  usuarioLogado!: UsuarioLogado;
  isCarrierTCMEnabled: boolean = true;
  isCarrierJSLEnabled: boolean = true;
  isCarrierJSLVWEnabled: boolean = true;
  isCarrierLOTSEnabled: boolean = true;
  isCarrierJSLARGEnabled: boolean = true;
  isCarrierEnabled: boolean = true;

  totalItensValidos!: number;
  valorDoisTotal!: number;
  valorUmTotal!: number;
  isLoading: boolean = true;
  fileName: string = 'Relatorio.xlsx';
  itemToExport!: any[];
  dataMilissegundos: number[] = [];
  somaTotalDistance!: number;
  somaWeightLoaded!: number;
  emissao!: number;
  searchTextSP: string = '';
  searchTextSul: string = '';
  searchTextArg: string = '';
  searchTextEmbalagem: string = '';
  searchTextInterplantas: string = '';
  count: number = 16;
  p: number = 1;
  veiculosPequenos!: number;
  veiculosMedios!: number;
  veiculosGrandes!: number;
  fillingRate!: number;
  itemsConcats!: any[];
  filterColumn: string = 'Janela 1';
  referenceDate!: string;
  numDays: number = 30;

  @ViewChild('dateInput') dateInput: any;
  @ViewChild('dateInput2') dateInput2: any;
  interplantasAmbArray!: any[];
  emissoesTotal!: number;
  carrosComErro: any[] = [];
  container: boolean = false;
  itemsContainers!: any[];
  searchTextArgEMB!: string;
  transportadoras!: string[];
  filtroAtual!: string;
  itemsContainersEXP!: any[];
  containerEXP: boolean = false;

  constructor(
    public dialog: MatDialog,
    private dynamodbService: ApiService,
    private http: HttpClient, private cdr: ChangeDetectorRef,
    private servicoAutenticacao: AutenticacaoService,
    private router: Router
  ) { }

  async ngOnInit(): Promise<void> {
    await this.getUserLogado();
    this.itemsConcats = [];
    this.filteredItems = [];
    this.veiculos = [];
    this.filtroAtual = 'Transportadoras';
    this.isLoading = false;
  }

  async update() {
    this.items = [];
    this.argentina = [];
    this.interplantasArray = [];
    this.embalagensArray = [];
    this.interplantasAmbArray = [];
    this.itemsContainers = [];
    this.itemsContainersEXP = [];
    this.itemsConcats = [];
    this.filteredItems = [];
    this.veiculos = [];
    try {
      if (this.milkRunArg || this.embalagens) {
        await this.getItemsFromArgentina();
      }
      if (this.milkRunSul || this.milkRunSP) {
        await this.getItemsFromDynamoDB();
      }
      if (this.container) {
        await this.getItemsContainer();
      }
      if (this.containerEXP) {
        await this.getItemsContainerEXP();
      }
      if (this.interplantas) {
        await this.getItemsFromInterplantas();
        await this.getItemsFromInterplantasAMB();
      }
      await this.getCarriersFromDynamoDB();
      await this.getVeiculosFromDynamoDB();
      await this.getVeiculosLAB();
      await this.getUserLogado();
      this.centerDialog();

      // console.log(this.items)
      // console.log(this.argentina)
      // console.log(this.interplantasArray)
      // console.log(this.embalagensArray)
      // console.log(this.interplantasAmbArray)
      // console.log(this.itemsContainers)

      this.itemsConcats = [
        ...(this.items || []),
        ...(this.argentina || []),
        ...(this.interplantasArray || []),
        ...(this.embalagensArray || []),
        ...(this.interplantasAmbArray || []),
        ...(this.itemsContainers || []),
        ...(this.itemsContainersEXP || []),
      ];

      this.filteredItems = [
        ...(this.items || []),
        ...(this.argentina || []),
        ...(this.interplantasArray || []),
        ...(this.embalagensArray || []),
        ...(this.interplantasAmbArray || []),
        ...(this.itemsContainers || []),
        ...(this.itemsContainersEXP || []),
      ];

      // this.itemsConcats = await this.items.concat(this.argentina).concat(this.interplantasArray).concat(this.embalagensArray).concat(this.interplantasAmbArray).concat(this.itemsContainers);
      // this.filteredItems = await this.items.concat(this.argentina).concat(this.interplantasArray).concat(this.embalagensArray).concat(this.interplantasAmbArray).concat(this.itemsContainers);
      this.veiculos = await this.veiculos.concat(this.veiculosLAB)


      this.filteredItems.sort((a, b) => {
        if (typeof a.dataReferencia === 'string' && typeof b.dataReferencia === 'string') {
          return b.dataReferencia.localeCompare(a.dataReferencia);
        } else {
          // Lógica para lidar com outros tipos ou tratar como números
          return b.dataReferencia - a.dataReferencia;
        }
      });

      await this.findVeiculoByModelo();
      await this.calcularMaiorValor();
      // //console.log(this.filteredItems)
      await this.somarQuantidades(this.filteredItems);
      await this.somarTotalDistance(this.filteredItems);
      await this.somarWeightLoaded(this.filteredItems);
      await this.somarEmissoesVeiculos(this.filteredItems);
      await this.calcularMediaMaiorValor();
      await this.calcularPorcentagemVeiculosPequenos();
      await this.calcularPorcentagemVeiculosMedios();
      await this.calcularPorcentagemVeiculosGrandes();

      await this.calcularEmissaoCO2(this.emissoesTotal, this.somaWeightLoaded);
    } catch (error) {
      console.error('Erro durante a execução do ngOnInit:', error);
    }
    this.p = 1;
    this.isLoading = false;
  }

  imprimeItem(item: any) {
    console.log(item)
  }

  async clearFilter() {
    this.filteredItems = this.itemsConcats;
    this.filteredItems.sort((a, b) => {
      if (typeof a.dataReferencia === 'string' && typeof b.dataReferencia === 'string') {
        return b.dataReferencia.localeCompare(a.dataReferencia);
      } else {
        // Lógica para lidar com outros tipos ou tratar como números
        return b.dataReferencia - a.dataReferencia;
      }
    });
    this.dateInput.nativeElement.value = '';
    this.dateInput2.nativeElement.value = '';
  }

  isDateInRange(date: Date, startDate: string, endDate: string): boolean {
    const rangeStartDate = new Date(startDate);
    const rangeEndDate = new Date(endDate);

    const dateYear = date.getFullYear();
    const dateMonth = date.getMonth();
    const dateDay = date.getDate();

    return (
      date >= new Date(rangeStartDate.getFullYear(), rangeStartDate.getMonth(), rangeStartDate.getDate()) &&
      date <= new Date(rangeEndDate.getFullYear(), rangeEndDate.getMonth(), rangeEndDate.getDate(), 23, 59, 59, 999) &&
      dateYear === rangeStartDate.getFullYear() &&
      dateMonth === rangeStartDate.getMonth() &&
      dateDay === rangeStartDate.getDate()
    );
  }

  async filterByDateRange(startDate: string, endDate: string): Promise<any[]> {
    let filteredItems = [];
    let itemDate = new Date('1970-01-01');
    // console.log(startDate)
    // console.log(endDate)
    const rangeStartDate = new Date(`${startDate}T00:00:00-03:00`);
    rangeStartDate.setHours(0, 0, 0, 0);
    const rangeEndDate = new Date(`${endDate}T00:00:00-03:00`);
    rangeEndDate.setHours(23, 59, 59, 999);
    filteredItems = this.itemsConcats.filter((item) => {
      // console.log(item.dataReferencia)
      if (typeof item.dataReferencia != 'undefined') {
        if (typeof item.dataReferencia == "string") {
          // console.log("entrou no primeiro if")
          // Verifica se a variável está no formato desejado
          const padrao: RegExp = /^\d{4}-\d{2}-\d{2}$/;
          const corresponde: boolean = padrao.test(item.dataReferencia);
          if (corresponde) {
            // Se a variável estiver no formato desejado, adiciona a parte de tempo
            item.dataReferencia = item.dataReferencia + "T00:00:00.000Z";
          } else {
            item.dataReferencia = item.dataReferencia
            // console.log("A variável não está no formato desejado.");
            // return;
          }
        } else if (typeof item.dataReferencia === "number") {
          // console.log("entrou no segundo if")

          // Se a variável for um número, assume que representa milissegundos desde a época
          // console.log("Tipo number.");
          const itemDateAux = new Date(item.dataReferencia);
          item.dataReferencia = itemDateAux.toISOString()
          // console.log(typeof item.date);
          // console.log(item.date);
        } else if (typeof item.dataReferencia === 'undefined') {
          // console.log("entrou no terceiro if")

          // Extrai partes da string
          // console.log(typeof item.ID);
          if (typeof item.ID === 'string') {
            const ano = parseInt(item.ID.substring(0, 4), 10);
            const mes = parseInt(item.ID.substring(4, 6), 10) - 1; // O mês é 0-indexed
            const dia = parseInt(item.ID.substring(6, 8), 10);
            const hora = parseInt(item.ID.substring(8, 10), 10);
            const minutos = parseInt(item.ID.substring(10, 12), 10);
            const segundos = parseInt(item.ID.substring(12, 14), 10);
            // Cria um objeto Date com as partes extraídas
            const itemDateAux = new Date(ano, mes, dia, hora, minutos, segundos);
            item.date = itemDateAux.toISOString()
            item.dataReferencia = itemDateAux.toISOString()
            // console.log(item.date);
          } else {
            const itemIDAux = item.ID.toString()
            // console.log(itemIDAux)
            const dia = parseInt(itemIDAux.substring(0, 2), 10);
            const mes = parseInt(itemIDAux.substring(2, 4), 10) - 1; // O mês é 0-indexed
            const ano = parseInt(itemIDAux.substring(4, 8), 10);
            const hora = parseInt(itemIDAux.substring(8, 10), 10);
            const minutos = parseInt(itemIDAux.substring(10, 12), 10);
            const segundos = parseInt(itemIDAux.substring(12, 14), 10);
            // Cria um objeto Date com as partes extraídas
            const itemDateAux = new Date(ano, mes, dia, hora, minutos, segundos);
            item.date = itemDateAux.toString()
            item.dataReferencia = itemDateAux.toString()
            // console.log(item.date);
          }
        }
      }
      else {
        // console.log("entrou no else")
        // item.date = new Date();
        // console.log("Tipo de variável não suportado.");
        // console.log(typeof item.date);
        // console.log(item);
        itemDate = new Date(item['Janela 1']);
        // console.log(itemDate);
        return;
      }

      // console.log(item);
      try {
        if (item.dataReferencia && item.dataReferencia.includes("Z")) {
          const date1str = item.dataReferencia.replace("Z", "");
          itemDate = new Date(date1str);
          // } else {
          //   if (isNaN(itemDate.getTime())) {
          //     console.log(item);
          //     console.log('A data é inválida.');
          //     itemDate = new Date(item['Janela 1']);
          //     console.log(itemDate);
          //   }
        }
      } catch {
        itemDate = new Date(item.date);
        // console.log(item);
        // console.log(itemDate);
        // console.log(typeof itemDate);
      }
      return itemDate >= rangeStartDate && itemDate <= rangeEndDate;

    });

    filteredItems.sort((a, b) => {
      if (typeof a.dataReferencia === 'string' && typeof b.dataReferencia === 'string') {
        return b.dataReferencia.localeCompare(a.dataReferencia);
      } else {
        // Lógica para lidar com outros tipos ou tratar como números
        return b.dataReferencia - a.dataReferencia;
      }
    });
    return [...filteredItems];
  }

  // filterItems() {
  //   let searchText = this.searchText.toLowerCase();
  //   this.filteredItems = this.filteredItems.filter(item => {
  //     const Plate = item.Plate ? item.Plate.toLowerCase() : '';
  //     const Fornecedor1 = item['Fornecedor 1'] ? item['Fornecedor 1'].toLowerCase() : '';
  //     const Fornecedor2 = item['Fornecedor 2'] ? item['Fornecedor 2'].toLowerCase() : '';
  //     const Fornecedor3 = item['Fornecedor 3'] ? item['Fornecedor 3'].toLowerCase() : '';
  //     const Fornecedor4 = item['Fornecedor 4'] ? item['Fornecedor 4'].toLowerCase() : '';
  //     const tipoVeiculo = item['Transport Type'] ? item['Transport Type'].toLowerCase() : '';
  //     return Plate.includes(searchText)
  //       || Fornecedor1.includes(searchText)
  //       || Fornecedor2.includes(searchText)
  //       || Fornecedor3.includes(searchText)
  //       || Fornecedor4.includes(searchText)
  //       || tipoVeiculo.includes(searchText);
  //   });
  // }

  filterItems() {
    // console.log(this.itemsConcats)
    // this.items = this.itemsConcats;
    if (!this.searchText) {
      this.filteredItems = this.itemsConcats;
    // this.filteredItems = this.filteredItems.filter(item => this.filtrarItem(item));  
    this.filteredItems.sort((a, b) => {
      if (typeof a.dataReferencia === 'string' && typeof b.dataReferencia === 'string') {
        return b.dataReferencia.localeCompare(a.dataReferencia);
      } else {
        // Lógica para lidar com outros tipos ou tratar como números
        return b.dataReferencia - a.dataReferencia;
      }
    });
  }else{
    this.filteredItems = this.filteredItems.filter(item => this.filtrarItem(item));  
    this.filteredItems.sort((a, b) => {
      if (typeof a.dataReferencia === 'string' && typeof b.dataReferencia === 'string') {
        return b.dataReferencia.localeCompare(a.dataReferencia);
      } else {
        // Lógica para lidar com outros tipos ou tratar como números
        return b.dataReferencia - a.dataReferencia;
      }
    });
  }
  }

  //adicionado filtro para todos os campos
  filtrarItem(item: any): boolean {
    // console.log(this.itemsConcats)
    if (!this.searchText) {
      console.log('entrou no filtro sem palavra')
      // Se o filtro estiver vazio, retorne verdadeiro para exibir todos os itens
      return true;
    }
    const lowerCaseFilter = this.searchText.toLowerCase();
    for (const prop in item) {
      if (item.hasOwnProperty(prop) && typeof item[prop] === 'string') {
        const lowerCaseProp = item[prop].toLowerCase();
        if (lowerCaseProp.includes(lowerCaseFilter)) {
          return true;
        }
      }
    }
    // console.log(this.itemsConcats)
    // Se nenhuma propriedade corresponder ao filtro, retornar falso para não exibir o item
    return false;
  }

  async editPlaca(item: any, fieldName: string) {
    if (!this.isValorValido(item[fieldName])) {
      const newValue = prompt(`Insert a value for ${fieldName}:`);
      if (newValue !== null) {
        item[fieldName] = newValue;
        await this.salvarField(item); // Call salvar function after editing the field
      }
    }
  }

  async InsereComent(item: any, fieldName: string) {
    // console.log(item)
    // console.log(item.date)
    // console.log(typeof item.date)
    const newValue = prompt(`Insert a value for ${fieldName}:`);
    if (newValue !== null) {
      item[fieldName] = newValue;
      await this.salvarField(item); // Call salvar function after editing the field
    }

  }

  getPercentComentNotEmpty(): number {
    const totalItems = this.filteredItems.length;
    const itemsWithComent = this.filteredItems.filter(item => this.hasComent(item)).length;
    return 100 - ((itemsWithComent / totalItems) * 100);
  }

  async editField(item: any, fieldName: string) {
    // console.log(item)
    if (!this.isValorValido(item[fieldName]) || this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      let newValue = prompt(`Insert a value for ${fieldName}:`);
      // Verifica se o valor é válido e não é nulo
      if (newValue !== null && newValue.trim() !== '') {
        // Remove as vírgulas do valor inserido
        const cleanedValue = newValue.replace(',', '.');
        // Converte o valor para o tipo number
        const numericValue = parseFloat(cleanedValue);
        // Verifica se é um número válido
        if (!isNaN(numericValue)) {
          item[fieldName] = numericValue;
          await this.salvarField(item); // Chama a função salvarField após editar o campo          
        } else {
          alert(`Invalid value for ${fieldName}. Please enter a valid number.`);
        }
      }
    }
  }


  isValorValido(value: any): boolean {
    return value != '' && value != null && value != undefined && value != 0;
  }

  // editDialog(item: any): void {
  //   this.item.ID = item.ID
  //   this.item.local = item.local;
  //   this.item.contato = item.contato;
  //   this.item.endereco = item.endereco;
  //   this.item.latitude = item.latitude;
  //   this.item.longitude = item.longitude;
  //   this.item.descarga = item.descarga;
  //   this.dialogOpen = true;
  // }

  async calcularMaiorValor() {
    // console.log("item")
    await this.filteredItems.forEach(async (item) => {
      if (item['Weight Loaded'] !== undefined && item.capacidadePeso !== undefined && item.Cubage !== undefined && item.capacidadeVolumetrica !== undefined) {
        item.pesoLoaded = this.isValorValido(item['Weight Loaded']) ? ((item['Weight Loaded'] / item.capacidadePeso) * 100) : 0;
        item.cub = this.isValorValido(item.Cubage) ? ((item.Cubage / item.capacidadeVolumetrica) * 100) : 0;
        item.fillingRateMax = Math.max(item.pesoLoaded, item.cub);
      } else {
        console.log(item.Plate);
        console.log('Weight Loaded ', item['Weight Loaded']);
        console.log('capacidadePeso ', item.capacidadePeso);
        console.log('Cubage ', item.Cubage);
        console.log('capacidadeVolumetrica ', item.capacidadeVolumetrica);
        console.log('pesoLoaded/capacidadePeso ', item.pesoLoaded);
        console.log('Cubage/capacidadeVolumetrica ', item.cub);
        console.log('fillingRate ', item.fillingRateMax);
      }
      item.modeloValido = await this.veiculos.some(veic => veic.modelo == item['Transport Type']);
    });
    const valores = this.filteredItems.map(item => [item.pesoLoaded, item.cub]);
    // console.log(this.filteredItems)
    return Math.max(...valores.flat());
  }

  async calcularMediaMaiorValor() {
    let soma = 0;
    let contador = 0;
    await this.filteredItems.forEach(item => {
      // console.log(item.fillingRateMax)
      if (!isNaN(item.fillingRateMax)) {
        soma += item.fillingRateMax;
        contador++;
      }else{
        console.log(item.Plate);
        console.log('Weight Loaded ', item['Weight Loaded']);
        console.log('capacidadePeso ', item.capacidadePeso);
        console.log('Cubage ', item.Cubage);
        console.log('capacidadeVolumetrica ', item.capacidadeVolumetrica);
        console.log('pesoLoaded/capacidadePeso ', item.pesoLoaded);
        console.log('Cubage/capacidadeVolumetrica ', item.cub);
        console.log('fillingRate ', item.fillingRateMax);
      }
    })
    // for (const item of this.filteredItems) {
    // console.log(item)
    //   soma += item.fillingRateMax;
    //   contador++;
    // }
    this.fillingRate = contador > 0 ? soma / contador : 0;
  }

  async onModelChange() {
    this.item.veiculoPerfil = await this.veiculos.find(veiculo => veiculo.modelo == this.item['Transport Type']).perfil;
    this.item.combustivel = await this.veiculos.find(veiculo => veiculo.modelo == this.item['Transport Type']).combustivel;
    this.item.emissao = await this.veiculos.find(veiculo => veiculo.modelo == this.item['Transport Type']).emissoes;
    this.item.consumo = await this.veiculos.find(veiculo => veiculo.modelo == this.item['Transport Type']).consumo;
    this.item.capacidadeVolumetrica = await this.veiculos.find(veiculo => veiculo.modelo == this.item['Transport Type']).volume;
    this.item.capacidadePeso = await this.veiculos.find(veiculo => veiculo.modelo == this.item['Transport Type']).peso;
    this.item.emissaoTotal = (this.item['Total Distance'] * this.item.emissao) / this.item.consumo;
    this.item.pesoLoaded = this.isValorValido(this.item['Weight Loaded']) ? ((this.item['Weight Loaded'] / this.item.capacidadePeso) * 100) : 0;
    this.item.cub = this.isValorValido(this.item.Cubage) ? ((this.item.Cubage / this.item.capacidadeVolumetrica) * 100) : 0;
    this.item.fillingRateMax = Math.max(this.item.pesoLoaded, this.item.cub);
    // console.log(this.veiculos.find(veiculo => veiculo.modelo == this.item['Transport Type']));
    // console.log(this.item);
  }

  async applyDateFilter() {
    this.filteredItems = [];
    // Apply filter only when both startDate and endDate are selected
    if (this.startDate && this.endDate) {
      this.filteredItems = await this.filterByDateRange(this.startDate, this.endDate);
      // console.log("depois do filtro")
      // console.log(this.filteredItems)
      await this.somarQuantidades(this.filteredItems);
      await this.somarTotalDistance(this.filteredItems);
      await this.somarWeightLoaded(this.filteredItems);
      await this.somarEmissoesVeiculos(this.filteredItems);
      await this.calcularEmissaoCO2(this.emissoesTotal, this.somaWeightLoaded);
      await this.calcularMediaMaiorValor();
      await this.calcularPorcentagemVeiculosPequenos();
      await this.calcularPorcentagemVeiculosMedios();
      await this.calcularPorcentagemVeiculosGrandes();
      await this.findVeiculoByModelo();
      await this.calcularMaiorValor();
      this.startDate = '';
      this.endDate = '';
      // //console.log(this.somaTotalDistance)
      // //console.log(this.filteredItems)
    } else {
      // Otherwise, show all items
      this.filteredItems = [...this.items, ...this.argentina, ...this.embalagensArray, ...this.interplantasArray, ...this.interplantasAmbArray, ...this.itemsContainers, ...this.itemsContainersEXP];
    }
    this.p = 1;
    // console.log(this.filteredItems)
  }

  async veiculoDialog(item: any) {
    console.log(item)
    this.item = item
    this.dialogTiposOpen = true;
  }

  async salvarVeiculo() {
    this.startDate = '';
    this.endDate = '';
    this.isLoading = true;
    if (this.item.ID === undefined) {
      const currentDate = new Date();
      const formattedDate = format(currentDate, 'ddMMyyyyHHmmss');
      this.item.ID = formattedDate.toString()
    }
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // //console.log(modifiedJsonString);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    console.log(jsonArray)
    await this.dynamodbService.salvar(jsonArray, "", this.urlAtualiza).subscribe(async response => {
      this.dialogTiposOpen = false;
      console.log('salvamento OK');
      await this.update();
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  async salvarField(item: any) {
    this.isLoading = true;
    this.startDate = '';
    this.endDate = '';
    await this.calcularMaiorValor();
    // Criar um array contendo o objeto
    const jsonArray = [item];
    await this.dynamodbService.salvar(jsonArray, this.query, this.urlAtualiza).subscribe(async response => {
      // Successfully saved to the database
      // setTimeout(() => {
      // await this.calcularMaiorValor();
      await this.getItemsFromDynamoDB();
      this.dialogOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  calcularSomaCustoViagem(): number {
    let soma = 0;
    for (const item of this.filteredItems) {
      const totalCost = parseFloat(item['Total Cost']);
      if (!isNaN(totalCost)) {
        soma += totalCost;
      }
    }
    return soma;
  }

  // Função auxiliar para somar as quantidades de '1' e '2' em todas as chaves específicas
  isValorValidoEhUmOuDois(value: any): boolean {
    return this.isValorValido(value) && (value == '1' || value == '2');
  }

  // Função auxiliar para somar as quantidades de '1' e '2' em todas as chaves específicas
  // somarQuantidades(): { valorUm: number, valorDois: number, totalItensValidos: number } {
  somarQuantidades(items: any[]) {
    // //console.log(items)
    this.valorUmTotal = 0;
    this.valorDoisTotal = 0;
    this.totalItensValidos = 0;
    const chavesEspecificas = [
      'Passo Destino1',
      'Passo Destino2',
      'Passo Destino3', // Adicione aqui as outras chaves específicas
      'Passo Destino4',
      'Passo Fornecedor1',
      'Passo Fornecedor2',
      'Passo Fornecedor3',
      'Passo Fornecedor4'
    ];
    for (const item of items) {
      for (const chave of chavesEspecificas) {
        if (this.isValorValidoEhUmOuDois(item[chave])) {
          if (item[chave] == '1' || item[chave] == 1) {
            this.valorUmTotal++;
          } else if (item[chave] == '2' || item[chave] == 2) {
            this.valorDoisTotal++;
          }
          this.totalItensValidos++;
        }
      }
    }
    return { valorUm: this.valorUmTotal, valorDois: this.valorDoisTotal, totalItensValidos: this.totalItensValidos };
  }

  isNumeroValido(value: any): number {
    if (value === null || value === undefined) {
      return 0;
    } else if (typeof value === 'number' && !isNaN(value) && isFinite(value)) {
      return value;
    } else if (typeof value === 'string') {
      const parsedValue = parseFloat(value);
      // //console.log(parsedValue)
      return isNaN(parsedValue) ? 0 : parsedValue;
    } else {
      return 0;
    }
  }

  // Função auxiliar para somar os valores válidos da chave 'Total Distance'
  somarTotalDistance(items: any[]) {
    this.somaTotalDistance = 0;
    // //console.log(items)
    for (const item of items) {
      const valorValido = this.isNumeroValido(item['Total Distance'])
      // if (this.isNumeroValido(item['Total Distance'])) {
      // //console.log(item['Total Distance'])
      // //console.log(valorValido)
      this.somaTotalDistance += valorValido;
      // }
    }
    // return this.somaTotalDistance;
  }

  somarWeightLoaded(items: any[]) {
    this.somaWeightLoaded = 0;
    for (const item of items) {
      const valorValido = this.isNumeroValido(item['Weight Loaded'])
      // if (this.isNumeroValido(item['Weight Loaded'])) {
      // console.log('somaWeightLoaded: ', valorValido)
      this.somaWeightLoaded += valorValido;
      // }
    }
    if (this.somaWeightLoaded > 0) {
      this.somaWeightLoaded = this.somaWeightLoaded / 1000;
    } else {
      this.somaWeightLoaded = 1;
    }
  }

  somarEmissoesVeiculos(items: any[]) {
    this.emissoesTotal = 0;
    for (const item of items) {
      const valorValido = this.isNumeroValido(item.emissaoTotal)
      // if (this.isNumeroValido(item['Weight Loaded'])) {
      // console.log('emissoesTotal: ', valorValido)
      this.emissoesTotal += valorValido;
      // }
    }
    // this.emissoesTotal = this.somaWeightLoaded / 1000;
  }

  calcularEmissaoCO2(emissaoTotal: number, pesoTotal: number) {
    this.emissao = 0;
    // //console.log(emissaoTotal)
    // //console.log(pesoTotal)
    this.emissao = emissaoTotal / pesoTotal;
    // //console.log(emissaoTotal / pesoTotal)
    // //console.log(this.emissao)
  }

  hasComent(item: any): boolean {
    return item.Coment !== '' && item.Coment !== null && item.Coment !== undefined;
  }


  async salvar() {
    this.isLoading = true;
    this.startDate = '';
    this.endDate = '';
    if (this.item.ID === undefined) {
      const currentDate = new Date();
      const formattedDate = format(currentDate, 'ddMMyyyyHHmmss');
      // //console.log(formattedDate);
      this.item = {
        "ID": formattedDate.toString(),
        "contato": this.item.contato,
        "endereco": this.item.endereco,
        "local": this.item.local,
        "latitude": this.item.latitude,
        "longitude": this.item.longitude,
        "descarga": this.item.descarga
      }
    }
    this.item.tableName = this.query
    // Remover as barras invertidas escapadas
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // //console.log(modifiedJsonString);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    await this.dynamodbService.salvar(jsonArray, this.query, this.urlAtualiza).subscribe(async response => {
      await this.getItemsFromDynamoDB();
      this.dialogOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  cancel(): void {
    this.dialogOpen = false;
    this.dialogTiposOpen = false;
  }

  findVeiculoByModelo() {
    this.filteredItems.forEach(item => {
      // if(item.Plate == "RUM4H94"){
      //   console.log(item)
      // }
      item.capacidadePeso = item.capacidadePeso ? item.capacidadePeso : this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).peso : 0
      item.capacidadeVolumetrica = item.capacidadeVolumetrica ? item.capacidadeVolumetrica : this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).volume : 0
      item.veiculoPerfil = item.veiculoPerfil ? item.veiculoPerfil : this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).perfil : 'Não encontrado'
      item.emissao = item.emissao ? item.emissao : this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).emissoes : 0
      item.consumo = item.consumo ? item.consumo : this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).consumo : 0
      item.emissaoTotal = item.emissaoTotal ? item.emissaoTotal : (item['Total Distance'] * item.emissao) / item.consumo;
      // //console.log(item.capacidadeVolumetrica)
    })
  }

  calcularPorcentagemVeiculosPequenos() {
    const totalVeiculos = this.filteredItems.length;
    const veiculosPequenos = this.filteredItems.filter(item => {
      return item.veiculoPerfil == 'Pequeno'
    });
    // //console.log(totalVeiculos)
    // //console.log(veiculosPequenos)
    this.veiculosPequenos = (veiculosPequenos.length / totalVeiculos) * 100;
  }

  calcularPorcentagemVeiculosMedios() {
    const totalVeiculos = this.filteredItems.length;
    const veiculosMedios = this.filteredItems.filter(item => {
      return item.veiculoPerfil == 'Medio';
      // //console.log(item.veiculoPerfil)
    });
    // //console.log(totalVeiculos)
    // //console.log(veiculosMedios)
    this.veiculosMedios = (veiculosMedios.length / totalVeiculos) * 100;
  }

  calcularPorcentagemVeiculosGrandes() {
    const totalVeiculos = this.filteredItems.length;
    const veiculosGrandes = this.filteredItems.filter(item => {
      // //console.log(item.veiculoPerfil)
      return item.veiculoPerfil == 'Grande';
    });
    // //console.log(totalVeiculos)
    // //console.log(veiculosGrandes)
    this.veiculosGrandes = (veiculosGrandes.length / totalVeiculos) * 100;
  }


  onNoClick(): void {
    this.dialogRef.close();
  }



  centerDialog(): void {
    const dialogRefElement = this.dialogRef?.containerInstance?.hostElement;
    if (dialogRefElement) {
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const dialogWidth = dialogRefElement.clientWidth;
      const dialogHeight = dialogRefElement.clientHeight;
      const top = Math.max(0, (windowHeight - dialogHeight) / 2);
      const left = Math.max(0, (windowWidth - dialogWidth) / 2);
      dialogRefElement.style.top = `${top}px`;
      dialogRefElement.style.left = `${left}px`;
    }
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  async getItemsFromDynamoDB(): Promise<void> {
    let referenceDateStart: string;
    let referenceDateEnd: string;
    if (this.startDate !== undefined && this.endDate !== undefined && this.startDate !== "Invalid Date" && this.endDate !== "Invalid Date" &&
      this.startDate !== "" && this.endDate !== "") {
      const startDate = new Date(this.startDate + "T00:00:00");
      const endDate = new Date(this.endDate + "T23:59:00");
      referenceDateStart = this.convertTimestampToFormattedDate(startDate.getTime());
      referenceDateEnd = this.convertTimestampToFormattedDate(endDate.getTime());
      // Calcula a diferença em milissegundos e converte para dias
      const diffInMs = endDate.getTime() - startDate.getTime();
      this.numDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
      this.numDays = this.numDays > 0 ? this.numDays : this.numDays = 1;
      // console.log(this.numDays)
    } else {
      // referenceDate = this.convertTimestampToFormattedDate(Date.now());
      referenceDateEnd = this.convertTimestampToFormattedDate(Date.now());
      const dataAtual = new Date();
      dataAtual.setHours(23, 59, 59, 999); // Define as horas, minutos, segundos e milissegundos
      // Subtrai 30 dias (30 dias * 24 horas * 60 minutos * 60 segundos * 1000 milissegundos)
      const diasParaSubtrair = 30;
      const dataPassada = new Date(dataAtual.getTime() - diasParaSubtrair * 24 * 60 * 60 * 1000);
      dataPassada.setHours(0, 0, 0, 0); // Define as horas, minutos, segundos e milissegundos
      referenceDateStart = this.convertTimestampToFormattedDate(dataPassada.getTime());
      this.numDays = 30;
      // console.log(this.numDays)
    }
    // console.log(referenceDateStart)
    // console.log(referenceDateEnd)
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsRangeData(this.query, this.urlConsultaRangeDatas, 'All', this.filterColumn, referenceDateStart, referenceDateEnd, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          ////console.log(items)
          if (Array.isArray(items)) {
            this.items = items
              .filter(item => this.shouldIncludeItem(item))
              .map(item => ({ ...item, checked: false }));
            this.items.forEach(item => {
              item.dataReferencia = item['JanelaDestino 1']
              if (item.description.toLowerCase().includes("jsl")) {
                item.Transportadora = "JSL"
              } else if (item.description.toLowerCase().includes("tcm")) {
                item.Transportadora = "TCM"
              }
            })
            // console.log(this.items)
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        this.startDate = '';
        this.endDate = '';
        alert("Range de data muito grande! Por favor, selecione um range menor.")
        console.error('Invalid response:', response);
      }
    } catch (error) {
      this.startDate = '';
      this.endDate = '';
      alert("Range de data muito grande! Por favor, selecione um range menor.")
      console.error(error);
    }
  }


  shouldIncludeItem(item: any): boolean {
    const description = item.description ? item.description : '';
    if (this.milkRunSP && (description.includes('JSL') || description.includes('jsl'))) {
      ////console.log(description)
      return true;
    }
    if (this.milkRunSul && (description.includes('tcm') || description.includes('TCM'))) {
      return true;
    }
    return false;
  }

  async getVeiculosFromDynamoDB(): Promise<void> {
    try {
      const filtro = '';
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.query3, this.urlConsultaCompleta, filtro)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculos = items;
            // console.log(this.veiculos)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getVeiculosLAB(): Promise<void> {
    try {
      const filtro = '';
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.queryVeiculosLab, this.urlConsultaCompleta, filtro)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculosLAB = items.map(item => ({ ...item, checked: false }));
            // console.log(this.veiculosLAB)
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  removeCommaAndConvertToNumber(numberString: string): number {
    // Remove the comma
    const cleanedString = numberString.toString().replace(/,/g, '');
    return parseFloat(cleanedString);
  }

  async getItemsFromArgentina(): Promise<void> {
    // console.log(this.startDate)
    // console.log(this.endDate)
    let referenceDateStart: string;
    let referenceDateEnd: string;
    if (this.startDate !== undefined && this.endDate !== undefined && this.startDate !== "Invalid Date" && this.endDate !== "Invalid Date" &&
      this.startDate !== "" && this.endDate !== "") {
      const startDate = new Date(this.startDate + "T00:00:00");
      const endDate = new Date(this.endDate + "T23:59:00");
      referenceDateStart = this.convertTimestampToFormattedDate(startDate.getTime());
      referenceDateEnd = this.convertTimestampToFormattedDate(endDate.getTime());
      // console.log(referenceDateStart)
      // console.log(referenceDateEnd)
      // Calcula a diferença em milissegundos e converte para dias
      const diffInMs = endDate.getTime() - startDate.getTime();
      this.numDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
      this.numDays = this.numDays > 0 ? this.numDays : this.numDays = 1;
      // console.log(this.numDays)
    } else {
      // referenceDate = this.convertTimestampToFormattedDate(Date.now());
      referenceDateEnd = this.convertTimestampToFormattedDate(Date.now());
      const dataAtual = new Date();
      dataAtual.setHours(23, 59, 59, 999); // Define as horas, minutos, segundos e milissegundos
      // Subtrai 30 dias (30 dias * 24 horas * 60 minutos * 60 segundos * 1000 milissegundos)
      const diasParaSubtrair = 30;
      const dataPassada = new Date(dataAtual.getTime() - diasParaSubtrair * 24 * 60 * 60 * 1000);
      dataPassada.setHours(0, 0, 0, 0); // Define as horas, minutos, segundos e milissegundos
      referenceDateStart = this.convertTimestampToFormattedDate(dataPassada.getTime());
      this.numDays = 30;
      // console.log(this.numDays)
    }
    // console.log(referenceDateStart)
    // console.log(referenceDateEnd)
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsRangeData(this.query4, this.urlConsultaRangeDatas, 'All', this.filterColumn, referenceDateStart, referenceDateEnd, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      // try {
      //   const response: any = await new Promise(async (resolve, reject) => {
      //     (await this.dynamodbService.getItems(this.query4, this.urlConsultaCompleta, 'All')).subscribe(
      //       (res: any) => resolve(res),
      //       (error: any) => reject(error)
      //     );
      //   });

      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          // //console.log(items)
          if (Array.isArray(items)) {
            this.argentina = items
              .filter(item => this.shouldIncludeArgentina(item))
              .map(item => ({ ...item, checked: false }));
            this.argentina.forEach(item => {
              // console.log(typeof item['Weight Loaded'])
              // console.log(item['Weight Loaded'])
              item.dataReferencia = item['JanelaDestino 1']
              item.Transportadora = "JSL"
              item['Weight Loaded'] = item['Weight Loaded'] ? this.removeCommaAndConvertToNumber(item['Weight Loaded']) : "";
            })
            this.embalagensArray = items
              .filter(item => this.shouldIncludeEmabalagens(item))
            this.cdr.detectChanges();
            // //console.log(this.embalagensArray)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        this.startDate = '';
        this.endDate = '';
        alert("Range de data muito grande! Por favor, selecione um range menor.")
        console.error('Invalid response:', response);
      }
    } catch (error) {
      this.startDate = '';
      this.endDate = '';
      alert("Range de data muito grande! Por favor, selecione um range menor.")
      console.error(error);
    }
  }

  async getItemsFromInterplantas(): Promise<void> {
    let referenceDateStart: string;
    let referenceDateEnd: string;
    if (this.startDate !== undefined && this.endDate !== undefined && this.startDate !== "Invalid Date" && this.endDate !== "Invalid Date" &&
      this.startDate !== "" && this.endDate !== "") {
      const startDate = new Date(this.startDate + "T00:00:00");
      const endDate = new Date(this.endDate + "T23:59:00");
      referenceDateStart = this.convertTimestampToFormattedDate(startDate.getTime());
      referenceDateEnd = this.convertTimestampToFormattedDate(endDate.getTime());
      // Calcula a diferença em milissegundos e converte para dias
      const diffInMs = endDate.getTime() - startDate.getTime();
      this.numDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
      this.numDays = this.numDays > 0 ? this.numDays : this.numDays = 1;
      // console.log(this.numDays)
    } else {
      // referenceDate = this.convertTimestampToFormattedDate(Date.now());
      referenceDateEnd = this.convertTimestampToFormattedDate(Date.now());
      const dataAtual = new Date();
      dataAtual.setHours(23, 59, 59, 999); // Define as horas, minutos, segundos e milissegundos
      // Subtrai 30 dias (30 dias * 24 horas * 60 minutos * 60 segundos * 1000 milissegundos)
      const diasParaSubtrair = 30;
      const dataPassada = new Date(dataAtual.getTime() - diasParaSubtrair * 24 * 60 * 60 * 1000);
      dataPassada.setHours(0, 0, 0, 0); // Define as horas, minutos, segundos e milissegundos
      referenceDateStart = this.convertTimestampToFormattedDate(dataPassada.getTime());
      this.numDays = 30;
      // console.log(this.numDays)
    }
    // console.log(referenceDateStart)
    // console.log(referenceDateEnd)
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsRangeData(this.queryInterplantas, this.urlConsultaRangeDatas, 'All', 'Janela', referenceDateStart, referenceDateEnd, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      // this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
      // try {
      //   const response: any = await new Promise(async (resolve, reject) => {
      //     (await this.dynamodbService.getItemsVolumesAltos(this.queryInterplantas, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays)).subscribe(
      //       (res: any) => resolve(res),
      //       (error: any) => reject(error)
      //     );
      //   });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          ////console.log(items)
          if (Array.isArray(items)) {
            this.interplantasArray = items.filter(item => this.shouldIncludeInterplantas(item))
            // //console.log(this.interplantasArray)
            await this.interplantasArray.forEach(item => {
              item.dataReferencia = item['Janela']
              item.date = item.date ? item.date : item.Janela
              item['Transport Type'] = item['Transport Type'] ? item['Transport Type'] : item.modelo && item.modelo != '' ? item.modelo : undefined
              item['Fornecedor 1'] = item['Fornecedor 1'] ? item['Fornecedor 1'] : 'LCB'
              item['Weight Loaded'] = item['Weight Loaded'] ? item['Weight Loaded'] : (item.Transportadora == 'LOTS' ? 25000 : 8800)
              item.Volumes = item.Volumes ? item.Volumes : 0
              item.Cubage = item.Cubage ? item.Cubage : 0
              item['Total Distance'] = item['Total Distance'] ? item['Total Distance'] : 16.6
              item['Total Cost'] = item['Total Cost'] ? item['Total Cost'] : 0
              item.veiculoPerfil = item.veiculoPerfil ? item.veiculoPerfil : this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).perfil : 'Grande'
            })
            this.cdr.detectChanges();
            // //console.log(this.interplantasArray)

          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        this.startDate = '';
        this.endDate = '';
        alert("Range de data muito grande! Por favor, selecione um range menor.")
        console.error('Invalid response:', response);
      }
    } catch (error) {
      this.startDate = '';
      this.endDate = '';
      alert("Range de data muito grande! Por favor, selecione um range menor.")
      console.error(error);
    }
  }

  async getItemsFromInterplantasAMB(): Promise<void> {
    // try {
    //   const response: any = await new Promise(async (resolve, reject) => {
    //     (await this.dynamodbService.getItems(this.queryInterplantasAmb, this.urlConsultaCompleta, 'All')).subscribe(
    //       (res: any) => resolve(res),
    //       (error: any) => reject(error)
    //     );
    //   });
    let referenceDateStart: string;
    let referenceDateEnd: string;
    if (this.startDate !== undefined && this.endDate !== undefined && this.startDate !== "Invalid Date" && this.endDate !== "Invalid Date" &&
      this.startDate !== "" && this.endDate !== "") {
      const startDate = new Date(this.startDate + "T00:00:00");
      const endDate = new Date(this.endDate + "T23:59:00");
      referenceDateStart = this.convertTimestampToFormattedDate(startDate.getTime());
      referenceDateEnd = this.convertTimestampToFormattedDate(endDate.getTime());
      // Calcula a diferença em milissegundos e converte para dias
      const diffInMs = endDate.getTime() - startDate.getTime();
      this.numDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
      this.numDays = this.numDays > 0 ? this.numDays : this.numDays = 1;
      // console.log(this.numDays)
    } else {
      // referenceDate = this.convertTimestampToFormattedDate(Date.now());
      referenceDateEnd = this.convertTimestampToFormattedDate(Date.now());
      const dataAtual = new Date();
      dataAtual.setHours(23, 59, 59, 999); // Define as horas, minutos, segundos e milissegundos
      // Subtrai 30 dias (30 dias * 24 horas * 60 minutos * 60 segundos * 1000 milissegundos)
      const diasParaSubtrair = 30;
      const dataPassada = new Date(dataAtual.getTime() - diasParaSubtrair * 24 * 60 * 60 * 1000);
      dataPassada.setHours(0, 0, 0, 0); // Define as horas, minutos, segundos e milissegundos
      referenceDateStart = this.convertTimestampToFormattedDate(dataPassada.getTime());
      this.numDays = 30;
      // console.log(this.numDays)
    }
    // console.log(referenceDateStart)
    // console.log(referenceDateEnd)
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsRangeData(this.queryInterplantasAmb, this.urlConsultaRangeDatas, 'All', 'Janela', referenceDateStart, referenceDateEnd, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.interplantasAmbArray = items.filter(item => this.shouldIncludeInterplantas(item))
            // //console.log(this.interplantasAmbArray)
            await this.interplantasAmbArray.forEach(item => {
              item.dataReferencia = item['Janela']
              item.date = item.plannedArrival
              item['Transport Type'] = item['Transport Type'] ? item['Transport Type'] : item.vehicle
              item['Fornecedor 1'] = item['Fornecedor 1'] ? item['Fornecedor 1'] : item.fornecedor
              item['Weight Loaded'] = item['Weight Loaded'] ? item['Weight Loaded'] : item.weight
              item.Volumes = 0
              item.Cubage = 0
              item.Transportadora = item.carrier
              item.Plate = item.Plate ? item.Plate : item.plate
              // item['']
              item['Total Distance'] = item['Total Distance'] ? item['Total Distance'] : item.distance
              item['Total Cost'] = item['Total Cost'] ? item['Total Cost'] : item.valorFrete
              item.veiculoPerfil = item.veiculoPerfil ? item.veiculoPerfil :
                this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).perfil :
                  'Pequeno'
            })
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        this.startDate = '';
        this.endDate = '';
        alert("Range de data muito grande! Por favor, selecione um range menor.")
        console.error('Invalid response:', response);
      }
    } catch (error) {
      this.startDate = '';
      this.endDate = '';
      alert("Range de data muito grande! Por favor, selecione um range menor.")
      console.error(error);
    }
  }

  async getItemsContainer(): Promise<void> {
    // this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    // try {
    //   const response: any = await new Promise(async (resolve, reject) => {
    //     (await this.dynamodbService.getItemsVolumesAltos(this.queryContainer, this.urlConsultaCompactada, 'All', "Janela", this.referenceDate, this.numDays)).subscribe(
    //       (res: any) => resolve(res),
    //       (error: any) => reject(error)
    //     );
    //   });
    let referenceDateStart: string;
    let referenceDateEnd: string;
    if (this.startDate !== undefined && this.endDate !== undefined && this.startDate !== "Invalid Date" && this.endDate !== "Invalid Date" &&
      this.startDate !== "" && this.endDate !== "") {
      const startDate = new Date(this.startDate + "T00:00:00");
      const endDate = new Date(this.endDate + "T23:59:00");
      referenceDateStart = this.convertTimestampToFormattedDate(startDate.getTime());
      referenceDateEnd = this.convertTimestampToFormattedDate(endDate.getTime());
      // Calcula a diferença em milissegundos e converte para dias
      const diffInMs = endDate.getTime() - startDate.getTime();
      this.numDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
      this.numDays = this.numDays > 0 ? this.numDays : this.numDays = 1;
      // console.log(this.numDays)
    } else {
      // referenceDate = this.convertTimestampToFormattedDate(Date.now());
      referenceDateEnd = this.convertTimestampToFormattedDate(Date.now());
      const dataAtual = new Date();
      dataAtual.setHours(23, 59, 59, 999); // Define as horas, minutos, segundos e milissegundos
      // Subtrai 30 dias (30 dias * 24 horas * 60 minutos * 60 segundos * 1000 milissegundos)
      const diasParaSubtrair = 30;
      const dataPassada = new Date(dataAtual.getTime() - diasParaSubtrair * 24 * 60 * 60 * 1000);
      dataPassada.setHours(0, 0, 0, 0); // Define as horas, minutos, segundos e milissegundos
      referenceDateStart = this.convertTimestampToFormattedDate(dataPassada.getTime());
      this.numDays = 30;
      // console.log(this.numDays)
    }
    console.log(referenceDateStart)
    console.log(referenceDateEnd)
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsRangeData(this.queryContainer, this.urlConsultaRangeDatas, 'All', 'Janela', referenceDateStart, referenceDateEnd, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          ////console.log(items)
          if (Array.isArray(items)) {
            this.itemsContainers = items.filter(item => this.shouldIncludeItemContainer(item))
            this.itemsContainers.forEach(container => {
              container.dataReferencia = container['Janela']
              if (!container['Total Distance'] && (container.distanceTrecho1 || container.distanceTrecho2)) {
                // console.log('Total Distance calculado')
                container['Total Distance'] = container.distanceTrecho1 + container.distanceTrecho2;
                container['emissaoTotal'] = container.emissaoTrecho1 + container.emissaoTrecho2;
                // console.log(container['ID'])
                // console.log(container['Total Distance'])
              } else {
                // console.log('com Total Distance')
                // console.log(container['ID'])
                // console.log(container['Total Distance'])
              }
              if (container.transportador) {
                if (container.transportador.toLowerCase().includes("lots")) {
                  container.Transportadora = "LOTS"
                } else if (container.transportador.toLowerCase().includes("glovis")) {
                  container.Transportadora = "GLOVIS"
                } else if (container.transportador.toLowerCase().includes("suzan")) {
                  container.Transportadora = "SUZAN"
                }
                container['Destino 1'] = container.terminalAtual;
                container['Destino 2'] = container.destino;
                container['Destino 3'] = container.destinoApos;
                container['Total Distance'] = parseFloat(container['Total Distance']);
              }
            });

            // this.itemsContainers.forEach(async container => {
            //   // container['Weight Loaded'] = 18400
            //   this.item = {
            //     ...container,
            //     "ID": container.ID,
            //     'Weight Loaded':  18400,
            //     'tableName': this.queryContainer
            //   }

            // // this.item.tableName = this.query
            // // Remover as barras invertidas escapadas
            // const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
            // const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
            // // Converter a string JSON para um objeto JavaScript
            // const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
            // // Converter o objeto JavaScript de volta para uma string JSON
            // const modifiedJsonString = JSON.stringify(jsonObject);
            // // //console.log(modifiedJsonString);
            // // Converter a string JSON para um objeto JavaScript
            // const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
            // // Criar um array contendo o objeto
            // const jsonArray = [jsonObject2];
            // console.log(jsonArray)
            // await this.dynamodbService.salvar(jsonArray, this.queryContainer, this.urlAtualiza).subscribe(async response => {
            // console.log('salvo com sucesso')

            //   // await this.getItemsFromDynamoDB();
            //   // this.dialogOpen = false;
            //   // this.isLoading = false;
            // }, error => {
            //   console.log(error);
            // });
            // })
            // console.log(this.itemsContainers)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        this.startDate = '';
        this.endDate = '';
        alert("Range de data muito grande! Por favor, selecione um range menor.")
        console.error('Invalid response:', response);
      }
    } catch (error) {
      this.startDate = '';
      this.endDate = '';
      alert("Range de data muito grande! Por favor, selecione um range menor.")
      console.error(error);
    }
  }

  async getItemsContainerEXP(): Promise<void> {
    let referenceDateStart: string;
    let referenceDateEnd: string;
    if (this.startDate !== undefined && this.endDate !== undefined && this.startDate !== "Invalid Date" && this.endDate !== "Invalid Date" &&
      this.startDate !== "" && this.endDate !== "") {
      const startDate = new Date(this.startDate + "T00:00:00");
      const endDate = new Date(this.endDate + "T23:59:00");
      referenceDateStart = this.convertTimestampToFormattedDate(startDate.getTime());
      referenceDateEnd = this.convertTimestampToFormattedDate(endDate.getTime());
      // Calcula a diferença em milissegundos e converte para dias
      const diffInMs = endDate.getTime() - startDate.getTime();
      this.numDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
      this.numDays = this.numDays > 0 ? this.numDays : this.numDays = 1;
      // console.log(this.numDays)
    } else {
      // referenceDate = this.convertTimestampToFormattedDate(Date.now());
      // referenceDateEnd = this.convertTimestampToFormattedDate(Date.now());
      referenceDateEnd = this.convertTimestampToFormattedDate(
        new Date().setHours(23, 59, 59, 999)
      );
      const dataAtual = new Date();
      dataAtual.setHours(23, 59, 59, 999); // Define as horas, minutos, segundos e milissegundos
      // Subtrai 30 dias (30 dias * 24 horas * 60 minutos * 60 segundos * 1000 milissegundos)
      const diasParaSubtrair = 30;
      const dataPassada = new Date(dataAtual.getTime() - diasParaSubtrair * 24 * 60 * 60 * 1000);
      dataPassada.setHours(0, 0, 0, 0); // Define as horas, minutos, segundos e milissegundos
      referenceDateStart = this.convertTimestampToFormattedDate(dataPassada.getTime());
      this.numDays = 30;
      // console.log(this.numDays)
    }
    console.log(referenceDateStart)
    console.log(referenceDateEnd)
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsRangeData(this.querycontainerEXP, this.urlConsultaRangeDatas, 'All', 'Janela', referenceDateStart, referenceDateEnd, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          // console.log(items)
          if (Array.isArray(items)) {
            this.itemsContainersEXP = items
              .filter(item => this.shouldIncludeItemContainerEXP(item))
            this.itemsContainersEXP.forEach(container => {
              container.dataReferencia = container['Janela']
              if (!container['Total Distance'] && (container.distanceTrecho1 || container.distanceTrecho2)) {
                // console.log('Total Distance calculado')
                container['Total Distance'] = container.distanceTrecho1 + container.distanceTrecho2;
                container['emissaoTotal'] = container.emissaoTrecho1 + container.emissaoTrecho2;
                // console.log(container['ID'])
                // console.log(container['Total Distance'])
              } else {
                // console.log('com Total Distance')
                // console.log(container['ID'])
                // console.log(container['Total Distance'])
              }
              if (container.transportador) {
                if (container.transportador.toLowerCase().includes("lots")) {
                  container.Transportadora = "LOTS"
                } else if (container.transportador.toLowerCase().includes("glovis")) {
                  container.Transportadora = "GLOVIS"
                } else if (container.transportador.toLowerCase().includes("suzan")) {
                  container.Transportadora = "SUZAN"
                }
              }
              container['Destino 1'] = container.terminalAtual;
              container['Destino 2'] = container.destino;
              container['Destino 3'] = container.destinoApos;
              container['Total Distance'] = parseFloat(container['Total Distance']);
            });
            // console.log(this.itemsContainersEXP)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        this.startDate = '';
        this.endDate = '';
        alert("Range de data muito grande! Por favor, selecione um range menor.")
        console.error('Invalid response:', response);
      }
    } catch (error) {
      this.startDate = '';
      this.endDate = '';
      alert("Range de data muito grande! Por favor, selecione um range menor.")
      console.error(error);
    }
  }

  getUniqueTransportadoras(data: any[]): string[] {
    const transportadoras = data.map(item => item.Transportadora || item.transportadora || item.carrier);
    return Array.from(new Set(transportadoras.filter(t => t))); // Remove duplicados e valores falsy
  }

  async filtrarTransportadora(event: Event) {
    await this.clearFilter();
    const selectElement = event.target as HTMLSelectElement;
    const transportadora = selectElement.value;

    if (transportadora) {
      this.filteredItems = this.filteredItems.filter(item =>
        item.Transportadora === transportadora || item.transportadora === transportadora
      );
    } else {
      await this.clearFilter();
    }
    await this.findVeiculoByModelo();
    await this.calcularMaiorValor();
    await this.somarQuantidades(this.filteredItems);
    await this.somarTotalDistance(this.filteredItems);
    await this.somarWeightLoaded(this.filteredItems);
    await this.somarEmissoesVeiculos(this.filteredItems);
    await this.calcularMediaMaiorValor();
    await this.calcularPorcentagemVeiculosPequenos();
    await this.calcularPorcentagemVeiculosMedios();
    await this.calcularPorcentagemVeiculosGrandes();
    await this.calcularEmissaoCO2(this.emissoesTotal, this.somaWeightLoaded);
  }

  shouldIncludeItemContainer(item: any): boolean {
    if (this.container) {
      return true;
    }
    return false;
  }

  shouldIncludeItemContainerEXP(item: any): boolean {
    if (this.containerEXP) {
      return true;
    }
    return false;
  }

  shouldIncludeArgentina(item: any): boolean {
    const description = item.description ? item.description : '';
    if (this.milkRunArg && (description.includes('arg') || description.includes('ARG')) && (!description.includes('EMBALAGEM') && !description.includes('embalagem'))) {
      return true;
    }
    return false;
  }

  shouldIncludeInterplantas(item: any): boolean {
    const description = item.description ? item.description : '';
    if (this.interplantas) {
      return true;
    }
    return false;
  }

  shouldIncludeEmabalagens(item: any): boolean {
    const description = item.description ? item.description : '';
    if (this.embalagens && (description.includes('embalagem') || description.includes('EMBALAGEM'))) {
      return true;
    }
    return false;
  }

  async getCarriersFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.query2, this.urlConsultaCompleta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.carrier = items.map(item => ({ ...item, checked: false }));
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
              // Forçar detecção de alterações após atualizar os dados
              this.cdr.detectChanges();
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async deleteItem(Item: any, urlDeleta: string, query: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      const ID = Item.ID;
      await this.dynamodbService.deleteItem(ID, this.urlAtualiza, Item.tableName).subscribe(
        async response => {
          // setTimeout(() => {
          await this.update();
          // }, 1200); // Ajuste o tempo de atraso conforme necessário
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }

  }

  async updateFilter() {
    this.isLoading = true;
    this.filtroAtual = 'Transportadoras';
    this.clearFilter();
    await this.update();
    this.transportadoras = this.getUniqueTransportadoras(this.filteredItems); // Obtém as opções
    // console.log(this.filteredItems)
    this.startDate = '';
    this.endDate = '';
    this.isLoading = false;
  }

  async milkRunSPFilter() {
    if (this.milkRunSP === true) {
      this.milkRunSP = false;
      this.searchTextSP = "";
    } else {
      this.milkRunSP = true;
      this.searchTextSP = "JSL";
    }
  }

  async milkRunSulFilter() {
    if (this.milkRunSul === true) {
      this.milkRunSul = false;
      this.searchTextSul = "";
    } else {
      this.milkRunSul = true;
      this.searchTextSul = "TCM"
    }
  }

  async milkRunArgFilter() {
    if (this.milkRunArg === true) {
      this.milkRunArg = false;
      this.searchTextArg = ""
    } else {
      this.milkRunArg = true;
      this.searchTextArg = "ARG"
    }
  }

  async interplantasFilter() {
    if (this.interplantas === true) {
      this.interplantas = false;
    } else {
      this.interplantas = true;
    }
  }

  async embalagemFilter() {
    if (this.embalagens === true) {
      this.embalagens = false;
      this.searchTextArgEMB = ""
    } else {
      this.embalagens = true;
      this.searchTextArgEMB = "EMBALAGEM"
    }
  }

  async containerFilter() {
    if (this.container === true) {
      this.container = false;
    } else {
      this.container = true;
    }
  }

  async containerFilterEXP() {
    if (this.containerEXP === true) {
      this.containerEXP = false;
    } else {
      this.containerEXP = true;
    }
  }

  async getUserLogado() {
    // //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    this.usuarioLogado = await this.servicoAutenticacao.obterUsuarioLogado()
    await this.enableFields();
    await this.enableFieldsTCM();
    await this.enableFieldsLOTS();
    await this.enableFieldsJSL();
    await this.enableFieldsJSLARG();
    await this.enableFieldsJSLVW();
    // //console.log(this.usuarioLogado)
    // //console.log(this.isCarrierEnabled)
    // //console.log(this.isCarrierTCMEnabled)
    // //console.log(this.isCarrierJSLARGEnabled)
    // //console.log(this.isCarrierLOTSEnabled)
    // //console.log(this.isCarrierJSLVWEnabled)
  }

  navigateTo(route: string): void {
    this.router.navigateByUrl(route);
  }

  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      this.isCarrierEnabled = false;
    }
  }

  enableFieldsTCM() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "TCM")) {
      this.isCarrierTCMEnabled = false;
    }
  }

  enableFieldsJSL() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL")) {
      this.isCarrierJSLEnabled = false;
    }
  }

  enableFieldsJSLARG() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL-ARG")) {
      this.isCarrierJSLARGEnabled = false;
    }
  }

  enableFieldsLOTS() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "LOTS")) {
      this.isCarrierLOTSEnabled = false;
    }
  }

  enableFieldsJSLVW() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL-VW")) {
      this.isCarrierJSLVWEnabled = false;
    }
  }

  // Função para ajustar os valores numéricos em um objeto
  adjustNumericValues(obj: any) {
    const adjustedObj = {} as Record<string, any>;
    for (const prop in obj) {
      if (typeof obj[prop] === 'number') {
        adjustedObj[prop] = obj[prop].toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } else if (typeof obj[prop] === 'object') {
        adjustedObj[prop] = this.adjustNumericValues(obj[prop]);
      } else {
        adjustedObj[prop] = obj[prop];
      }
    }
    return adjustedObj;
  }

  //EXPORTAR EXCEL
  exportExcel() {
    const confirmacao = window.confirm("Todas as informações devem estar preenchidas. Campos em vermelho impedem a exportação do arquivo!");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      try {
        // debugger
        // Criar um novo array com valores numéricos ajustados
        const newArrayWithAdjustedValues = this.filteredItems.map(item => this.adjustNumericValues(item));
        this.itemToExport = newArrayWithAdjustedValues;
        this.itemToExport.forEach((item, index) => this.dataMilissegundos[index] ? this.dataMilissegundos[index] = parseInt((item.date.replace(/[.,]/g, '')).toString().slice(0, -2)) : 0)
        // //console.log(this.dataMilissegundos)

        this.itemToExport = this.itemToExport.map((item, index) => {
          try {
            let obj: ItemToExport = {
              ID: item.ID,
              table_name: item.table_name,
              Data: this.addTimeStringToDate(item) ? this.addTimeStringToDate(item) : 'sem data',
              // Data: item.Data,
              Vehicle_configuration: item["Transport Type"],
              License_Plate: item.Plate ? item.Plate : item.placa ? item.placa : item.plate ? item.plate : '',
              Transportadora: item.transportador ? item.transportador : item.Transportadora ? item.Transportadora : '',
              container: item.idContainer ? item.idContainer : '',
              consumo: item.consumo,
              emissao: item.emissao,
              Distancia: item["Total Distance"] ? parseFloat(item["Total Distance"].replace(/\./g, "").replace(",", ".")) : 0,
              emissaoTotal: item.emissaoTotal,
              Ponto_Coleta1: item["Fornecedor 1"],
              Ponto_Coleta2: item["Fornecedor 2"],
              Ponto_Coleta3: item["Fornecedor 3"],
              Ponto_Coleta4: item["Fornecedor 4"],
              Ponto_Entrega1: item["Destino 1"],
              Ponto_Entrega2: item["Destino 2"],
              Ponto_Entrega3: item["Destino 3"],
              Ponto_Entrega4: item["Destino 4"],
              Qtde_Itens: item.Volumes ? parseFloat(item.Volumes.replace(/\./g, "").replace(",", ".")) : 0,
              Cubagem_m3: item.Cubage ? parseFloat(item.Cubage.replace(/\./g, "").replace(",", ".")) : 0,
              Peso_Total_Kg: item["Weight Loaded"] ? parseFloat(item["Weight Loaded"].replace(/\./g, "").replace(",", ".")) : 0,
              Custo_Viagem: item["Total Cost"] ? parseFloat(item["Total Cost"].replace(/\./g, "").replace(",", ".")) : 0
            };

            // Filtrar as colunas que têm valor (remover null, undefined, ou strings vazias)
            obj = Object.fromEntries(
              Object.entries(obj).filter(([_, value]) => value !== null && value !== undefined && value !== '')
            );
            return obj;

          } catch (error) {
            // Handle the error here, you can log it or perform any other action
            this.carrosComErro.push(item);
            // console.log(item)
            this.isLoading = false;
            let errorMessage = "Cars with errors:\n";
            for (let i = 0; i < this.carrosComErro.length; i++) {
              errorMessage += `Plate: ${this.carrosComErro[i].Plate}, Date: ${this.carrosComErro[i].Date}\n`;
            }
            window.confirm(errorMessage);
            console.error("Error processing item at index", index, ":", error);
            // If you want to skip this item, you can return null or an empty object
            return null;
          }
        }).filter(item => item !== null); // Filter out the items which failed to process

        console.log(this.itemToExport)
        const fileName = 'Relatório E-Transport'; // Nome do arquivo Excel
        this.exportSubsetToExcel(this.itemToExport, fileName);
      }
      catch (error) {
        this.isLoading = false;
        let errorMessage = "Cars with errors:\n";
        for (let i = 0; i < this.carrosComErro.length; i++) {
          errorMessage += `Plate: ${this.carrosComErro[i].Plate}, Date: ${this.carrosComErro[i].Date}\n`;
        }
        // console.log(this.carrosComErro)
        window.confirm(errorMessage);
        // window.confirm("Erro!");
        console.error('Error parsing JSON:', error);
      }
    }
    this.isLoading = false;
  }

  isValidDate(dateString: string): boolean {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }

  addTimeStringToDate(item: any): string {
    var newDate;
    if (item.date) {
      if (item.date.includes("T")) {
        newDate = this.formatStringDate(item.date)
        console.log("com item.data")
        console.log(item.date)
        console.log(newDate)
      } else {
        var data = parseInt((item.date.replace(/[.,]/g, '')).toString().slice(0, -2))
        newDate = this.formatMillisecondsToDate(data)
        console.log("com data como var")
        console.log(data)
        console.log(newDate)
      }
      return newDate;
    }
    return '0';
  }

  // Função para exportar um subconjunto específico do objeto para um arquivo Excel
  exportSubsetToExcel(subsetData: any[], fileName: string) {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(subsetData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

  formatMillisecondsToDate(milliseconds: number) {
    // //console.log(milliseconds)
    const date = new Date(milliseconds);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  }

  // formatStringDate(inputDate: string) {
  //   const date = new Date(inputDate);
  //   const day = date.getDate();
  //   const month = date.getMonth() + 1;
  //   const year = date.getFullYear();
  //   return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  // }

  formatStringDate(inputDate: string) {
    const date = new Date(inputDate);
    // Pegando os valores como UTC para evitar conversão de fuso horário
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  }

}
